import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchMovieDetails } from '../api/api';

const MovieDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/original';

  useEffect(() => {
    const getDetails = async () => {
      const data = await fetchMovieDetails(id);
      setDetails(data);
    };
    getDetails();
  }, [id]);
  const BackButton = () => {
    const navigate = useNavigate();
  
    const buttonStyle = {
      padding: '10px 20px',
      backgroundColor: '#3498db',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontWeight: '500',
      margin: '20px 0'
    };
  
    const iconStyle = {
      marginRight: '8px'
    };
  
    return (
      <button 
        style={buttonStyle}
        onClick={() => navigate(-1)}
      >
        <span style={iconStyle}>←</span>
        Back to Movies
      </button>
    );
  };
  return (
    <div className="container mt-5">
      <button 
        className="btn back-button text-white mb-4"
        onClick={() => navigate(-1)}
      >
        <i className="fas fa-arrow-left me-2"></i>
        Back to Movies
      </button>
      
      {details && (
        <div className="movie-details-page">
          <div className="row">
            <div className="col-md-4">
              <img
                src={`${IMAGE_BASE_URL}${details.poster_path}`}
                alt={details.title}
                className="img-fluid rounded shadow movie-poster"
              />
            </div>
            
            <div className="col-md-8">
              <div className="movie-info">
                <h1 className="movie-title">{details.title}</h1>
                
                <div className="mb-4">
                  <span className="rating-badge">
                    <i className="fas fa-star me-1"></i>
                    {details.vote_average.toFixed(1)} / 10
                  </span>
                </div>

                <div className="mb-3">
                  <span className="info-label">Release Date:</span>
                  {new Date(details.release_date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>

                <div className="mb-4">
                  <p className="info-label">Overview:</p>
                  <p className="lead">{details.overview}</p>
                </div>

                <div className="mb-3">
                  <span className="info-label">Genres:</span>
                  <div>
                    {details.genres?.map(genre => (
                      <span key={genre.id} className="genre-tag">
                        {genre.name}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mb-3">
                  <span className="info-label">Language:</span>
                  {details.original_language.toUpperCase()}
                </div>

                <div className="mb-3">
                  <span className="info-label">Runtime:</span>
                  {details.runtime} minutes
                </div>
              </div>
            </div>
          </div>
          <BackButton />
        </div>
      )}

      {!details && (
        <div className="loading-spinner">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading movie details...</p>
        </div>
      )}
    </div>
  );
};

export default MovieDetailsPage;